/* eslint-disable max-len, padded-blocks, prefer-destructuring */

export default {
  computed: {
    projectWorkOrderBillableRemaining() {
      let projectWorkOrderBillableRemaining = this.projectWorkOrderBillModel.workOrderTotal - this.projectWorkOrderBillModel.otherBillsTotal - this.getBillPaymentTotal(this.projectWorkOrderBillModel);
      projectWorkOrderBillableRemaining = Math.round(projectWorkOrderBillableRemaining * 100) / 100;
      return projectWorkOrderBillableRemaining;
    },
  },
  methods: {
    getWorkorderTotal(workOrder) {
      const workOrderLineItems = workOrder.workOrderLineItems || [];
      const workOrderIncentives = workOrder.workOrderProjectIncentives || [];

      const workOrderLineItemTotals = workOrderLineItems.map((e) => (e.quantity * e.salePrice));
      const workOrderIncentiveTotals = workOrderIncentives.map((e) => (e.paymentAmount));

      let workOrderLineItemTotal = 0;
      let workOrderIncentiveTotal = 0;

      if (workOrderLineItemTotals.length > 0) {
        workOrderLineItemTotal = workOrderLineItemTotals.reduce((a, b) => a + b);
      }
      if (workOrderIncentiveTotals.length > 0) {
        workOrderIncentiveTotal = workOrderIncentiveTotals.reduce((a, b) => a + b);
      }

      workOrderLineItemTotal = Math.round(workOrderLineItemTotal * 100) / 100;
      workOrderIncentiveTotal = Math.round(workOrderIncentiveTotal * 100) / 100;

      return workOrderLineItemTotal + workOrderIncentiveTotal;
    },
    getWorkorderIncentivePaymentTotal(workOrder) {
      const workOrderIncentives = workOrder.workOrderProjectIncentives || [];
      const workOrderIncentivesTotals = workOrderIncentives.map((e) => e.paymentAmount);

      let workOrderIncentiveTotal = 0;
      if (workOrderIncentivesTotals.length > 0) {
        workOrderIncentiveTotal = workOrderIncentivesTotals.reduce((a, b) => a + b);
      }
      workOrderIncentiveTotal = Math.round(workOrderIncentiveTotal * 100) / 100;
      return workOrderIncentiveTotal;
    },
    getOtherBillsTotal(workOrder) {
      let workOrderBills = workOrder.workOrderBills || [];
      workOrderBills = workOrderBills.filter(
        (e) => e.status !== this.config.workOrderBillForm.submitStatus.Voided,
      );

      const workOrderBillLineItems = workOrderBills.map(
        (item) => item.workOrderBillLineItems,
      ).flat();

      const workOrderBillLineItemTotals = workOrderBillLineItems.map((e) => (e.quantity * e.salePrice));

      let workOrderBillLineItemTotal = 0;
      if (workOrderBillLineItemTotals.length > 0) {
        workOrderBillLineItemTotal = workOrderBillLineItemTotals.reduce((a, b) => a + b);
      }
      workOrderBillLineItemTotal = Math.round(workOrderBillLineItemTotal * 100) / 100;

      const workOrderBillIncentives = workOrderBills.map(
        (item) => item.workOrderBillIncentivePayments,
      ).flat();

      const workOrderBillIncentiveTotals = workOrderBillIncentives.map((e) => e.amountBilled);

      let workOrderBillIncentiveTotal = 0;
      if (workOrderBillIncentiveTotals.length > 0) {
        workOrderBillIncentiveTotal = workOrderBillIncentiveTotals.reduce((a, b) => a + b);
      }
      workOrderBillIncentiveTotal = Math.round(workOrderBillIncentiveTotal * 100) / 100;

      return workOrderBillLineItemTotal + workOrderBillIncentiveTotal;
    },
    getOtherWorkOrderBillTotal(workOrder, workOrderBill) {
      let workOrderBills = workOrder.workOrderBills || [];
      workOrderBills = workOrderBills.filter(
        (e) => e.status !== this.config.workOrderBillForm.submitStatus.Voided && e.id !== workOrderBill.id,
      );

      const workOrderBillLineItems = workOrderBills.map(
        (item) => item.workOrderBillLineItems,
      ).flat();

      const workOrderBillLineItemTotals = workOrderBillLineItems.map((e) => (e.quantity * e.salePrice));

      let workOrderBillTotal = 0;
      if (workOrderBillLineItemTotals.length > 0) {
        workOrderBillTotal = workOrderBillLineItemTotals.reduce((a, b) => a + b);
      }
      workOrderBillTotal = Math.round(workOrderBillTotal * 100) / 100;
      return workOrderBillTotal;
    },
  },
};
